import supportsWebP from "supports-webp";

export const fetchWrapper = (url, {body, ...customConfig} = {}) => {
    const headers = {'Content-Type': 'application/json'};

    const config = {
        method: body ? 'POST' : 'GET',
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
        },
    };

    if (body) {
        config.body = JSON.stringify(body)
    }

    return window
        .fetch(url, config)
        .then(async response => {
            const data = await response.json()
            if (response.ok) {
                return data;
            } else {
                return Promise.reject(data)
            }
        })
};

export const getCookie = name => {
    // eslint-disable-next-line
    const regex = new RegExp('(?:^|; )' + name.replace(/([$?*|{}\[\]\\\/^])/g, '\\$1') + '=([^;]*)');
    let matches = document.cookie.match(regex);
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const calcPercent = (partialValue, totalValue) => (100 * partialValue) / totalValue;

  export const checkoutImagesLinks = [
    '../assets/visa.png',
    '../assets/mastercard.png',
    '../assets/amex.png',
    '../assets/discover.png',
    '../assets/money-back.svg'
  ]

  export const checkoutWebpImagesLinks = [
    '../assets/visa.webp',
    '../assets/mastercard.webp',
    '../assets/amex.webp',
    '../assets/discover.webp',
    '../assets/money-back.svg'
  ]

  export const plansImagesLinks = [
    '../assets/reviewer1.png',
    '../assets/reviewer2.png',
    '../assets/reviewer3.png',
    '../assets/app-icon.png',
    '../assets/stars.png'
  ]

  export const successImagesLinks = [
    '../assets/AppStore.svg',
    '../assets/GooglePlay.svg',
    '../assets/store-stars.svg',
  ]

  export const logoImagesLinks = [
    '../assets/fl-logo.png',
    '../assets/converted-logo.png'
  ]

  export const logoWebpImagesLinks = [
    '../assets/fl-logo.webp',
    '../assets/converted-logo.webp'
  ] 

export const canUseWebp = async () => {
    return await supportsWebP;
};

